var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCompany = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 36C27.9411 36 36 27.9411 36 18C36 8.05888 27.9411 0 18 0C8.05888 0 0 8.05888 0 18C0 27.9411 8.05888 36 18 36Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9999 35.4705C27.6486 35.4705 35.4705 27.6486 35.4705 17.9999C35.4705 8.35115 27.6486 0.529297 17.9999 0.529297C8.35115 0.529297 0.529297 8.35115 0.529297 17.9999C0.529297 27.6486 8.35115 35.4705 17.9999 35.4705Z",
    stroke: "#9D9D9D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7778 26C11.3484 26 11 25.6416 11 25.2V10.8C11 10.3584 11.3484 10 11.7778 10H19.5556C19.9849 10 20.3333 10.3584 20.3333 10.8V16.4H24.2222C24.6516 16.4 25 16.7584 25 17.2V25.2C25 25.6416 24.6516 26 24.2222 26H11.7778ZM16.4444 24.4H18.7778V11.6H12.5556V24.4H14.8889V22.8C14.8889 22.3584 15.2373 22 15.6667 22C16.096 22 16.4444 22.3584 16.4444 22.8V24.4ZM20.3333 18V24.4H23.4444V18H20.3333ZM14.8889 18H16.4444C16.8738 18 17.2222 17.6416 17.2222 17.2C17.2222 16.7584 16.8738 16.4 16.4444 16.4H14.8889C14.4596 16.4 14.1111 16.7584 14.1111 17.2C14.1111 17.6416 14.4596 18 14.8889 18ZM14.8889 14.8H16.4444C16.8738 14.8 17.2222 14.4416 17.2222 14C17.2222 13.5584 16.8738 13.2 16.4444 13.2H14.8889C14.4596 13.2 14.1111 13.5584 14.1111 14C14.1111 14.4416 14.4596 14.8 14.8889 14.8Z",
    fill: "#9D9D9D"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCompany);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/company.d9812c3224a1718b0918ab80e64aeae2.svg";